// SVG Icons Collection for DogGoods Store
// Extracted from Lucide React for consistent iconography

const DogGoodsIcons = {
  star: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26 12,2"></polygon>
  </svg>`,
  
  shoppingCart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <path d="M16 10a4 4 0 0 1-8 0"></path>
  </svg>`,
  
  heart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>`,
  
  share2: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
  </svg>`,
  
  shield: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>`,
  
  truck: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <rect x="1" y="3" width="15" height="13"></rect>
    <polygon points="16,6 16,16 20,16 22,10 18,6 16,6"></polygon>
    <circle cx="5.5" cy="18.5" r="2.5"></circle>
    <circle cx="18.5" cy="18.5" r="2.5"></circle>
  </svg>`,
  
  rotateCcw: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M1 4v6h6"></path>
    <path d="M23 20v-6h-6"></path>
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
  </svg>`,
  
  plus: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>`,
  
  minus: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>`,
  
  checkCircle: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M9 12l2 2 4-4"></path>
    <circle cx="12" cy="12" r="10"></circle>
  </svg>`,
  
  package: `<svg viewBox="0 0 16 16" fill="none">
    <path d="M7.99999 2.6001V13.4001M12.2003 5.6001L14.0005 10.4001C13.4811 10.7896 12.8495 11.0001 12.2003 11.0001C11.5512 11.0001 10.9195 10.7896 10.4002 10.4001L12.2003 5.6001ZM12.2003 5.6001V5.0001M2.59956 5.0001H3.19961C4.87398 5.0001 6.52261 4.58797 7.99999 3.8001C9.47738 4.58797 11.126 5.0001 12.8004 5.0001H13.4004M3.79966 5.6001L5.5998 10.4001C5.08047 10.7896 4.44882 11.0001 3.79966 11.0001C3.15049 11.0001 2.51884 10.7896 1.99951 10.4001L3.79966 5.6001ZM3.79966 5.6001V5.0001M4.99975 13.4001H11.0002" stroke="#74AB3A" stroke-width="2" stroke-linecap="round"/>
  </svg>`,

  'dog-size': `<svg viewBox="0 0 16 16" fill="none">
    <path d="M12.2695 8.52246C14.1768 8.5225 15.7285 10.0742 15.7285 11.9814C15.7285 13.8887 14.1768 15.4404 12.2695 15.4404C10.3622 15.4404 8.81055 13.8888 8.81055 11.9814C8.81056 10.0741 10.3622 8.52246 12.2695 8.52246ZM12.2695 9.60352C10.9587 9.60352 9.8916 10.6706 9.8916 11.9814C9.89161 13.2923 10.9587 14.3594 12.2695 14.3594C13.5803 14.3593 14.6475 13.2923 14.6475 11.9814C14.6475 10.6706 13.5803 9.60356 12.2695 9.60352ZM12.9873 10.8906C13.1771 10.6603 13.5176 10.6269 13.748 10.8164C13.9785 11.0063 14.0122 11.3477 13.8223 11.5781L12.5898 13.0723C12.4961 13.1861 12.3599 13.2576 12.2129 13.2686C12.1995 13.2696 12.186 13.2695 12.1729 13.2695C12.0397 13.2695 11.9102 13.2206 11.8105 13.1309L10.7725 12.1943C10.5508 11.9945 10.5326 11.6524 10.7324 11.4307C10.9324 11.2089 11.2743 11.1917 11.4961 11.3916L12.1152 11.9482L12.9873 10.8906ZM7.50195 0.56543C8.80228 0.497989 9.85949 1.03543 10.543 2.11426L10.5459 2.11914L10.5469 2.12012C10.7668 2.47819 10.9759 2.71826 11.4277 2.87891C11.8964 3.04551 12.6313 3.12793 13.9111 3.12793C14.1212 3.12797 14.3126 3.24997 14.4014 3.44043C14.4338 3.51 14.5799 3.84064 14.6562 4.26758C14.7321 4.69197 14.7428 5.23385 14.4766 5.70996C14.1873 6.22706 13.6629 6.52074 12.9551 6.60254C12.1587 6.69454 11.5477 6.8852 11.1406 7.14648C10.7374 7.40529 10.5439 7.72488 10.5439 8.08594C10.5437 8.38423 10.3022 8.62578 10.0039 8.62598C9.70549 8.62598 9.46311 8.38435 9.46289 8.08594C9.46289 7.75461 9.54903 7.19573 10.0254 6.67676C10.5012 6.15857 11.3485 5.6996 12.8311 5.52832C13.2268 5.48258 13.4347 5.35688 13.5322 5.18359C13.6081 5.04866 13.6307 4.86585 13.6162 4.66406C13.6048 4.50434 13.5682 4.34399 13.5283 4.20508C12.4077 4.18952 11.6149 4.10237 11.0156 3.87793C10.3863 3.64217 9.97919 3.26084 9.62793 2.69043L9.53711 2.55566C9.07005 1.90619 8.41077 1.60117 7.55762 1.64551C7.53695 1.64658 7.51652 1.64992 7.49609 1.65137C7.73942 2.0572 7.99177 2.6341 8.33301 3.41309C8.41863 3.60851 8.5105 3.81681 8.6084 4.03809C9.39105 5.80607 9.03829 6.83752 8.72852 7.31348C8.41351 7.79741 7.91416 8.08104 7.3584 8.08105C6.80658 8.08105 6.30551 7.7046 5.91309 7.12305C5.51792 6.53735 5.21324 5.71705 5.05566 4.76172C4.99174 4.37413 4.95018 4.01252 4.92773 3.67871C4.60824 4.44848 4.4471 5.3751 4.46289 6.41211C4.49467 8.49099 3.54876 9.77632 2.74707 10.4863C1.88692 11.248 1.01767 11.5186 0.969727 11.5332C0.91766 11.549 0.864693 11.5566 0.8125 11.5566C0.580736 11.5566 0.365833 11.4064 0.294922 11.1729C0.219404 10.9234 0.333446 10.662 0.553711 10.542L0.654297 10.499C0.683227 10.4897 1.37827 10.262 2.05176 9.65723C2.95245 8.84817 3.40227 7.76636 3.38184 6.42871C3.31935 2.33219 5.64538 1.0573 5.77637 0.989258H5.77734L5.94336 0.916016C6.20821 0.808552 6.79829 0.601832 7.50195 0.56543ZM6.33008 1.92578C6.22903 1.97478 6.09117 2.15269 6.02539 2.59766C5.96132 3.03113 5.97221 3.67733 6.12207 4.58594C6.2543 5.38753 6.49571 6.00361 6.74707 6.41504C6.87299 6.62112 6.99984 6.77158 7.1123 6.86914C7.22874 6.97012 7.31301 7 7.3584 7C7.53663 7 7.70152 6.90912 7.82227 6.72363C7.944 6.53658 8.24155 5.88177 7.61914 4.47559C7.52063 4.25303 7.42867 4.04376 7.34277 3.84766C7.00947 3.08672 6.77476 2.55068 6.56934 2.20801C6.50426 2.09953 6.44552 2.00357 6.37305 1.93555C6.36238 1.92554 6.35559 1.91963 6.35156 1.91699L6.33008 1.92578Z" fill="#74AB3A" stroke="#74AB3A" stroke-width="0.3"/>
  </svg>`,

  'ruler-green': `<svg viewBox="0 0 24 24" fill="none">
    <path d="M14.2506 12.4504L16.0505 10.6505M11.5507 9.7506L13.3506 7.95072M8.85091 7.05077L10.6508 5.25089M16.9504 15.1503L18.7503 13.3504M20.37 14.9701C20.5714 15.1708 20.7311 15.4092 20.8401 15.6717C20.9492 15.9343 21.0053 16.2157 21.0053 16.5C21.0053 16.7843 20.9492 17.0657 20.8401 17.3283C20.7311 17.5908 20.5714 17.8293 20.37 18.0299L18.0302 20.3698C17.8295 20.5711 17.5911 20.7309 17.3285 20.8399C17.066 20.9489 16.7845 21.005 16.5003 21.005C16.216 21.005 15.9345 20.9489 15.672 20.8399C15.4094 20.7309 15.171 20.5711 14.9703 20.3698L3.63105 9.03047C3.22658 8.62404 2.99951 8.07397 2.99951 7.50057C2.99951 6.92717 3.22658 6.3771 3.63105 5.97066L5.97091 3.63081C6.37734 3.22633 6.92741 2.99927 7.50081 2.99927C8.07421 2.99927 8.62428 3.22633 9.03072 3.63081L20.37 14.9701Z" stroke="#74AB3A" stroke-width="2" stroke-linecap="round"/>
  </svg>`,

  'x-modal': `<svg viewBox="0 0 22 22" fill="none">
    <path d="M13.5003 8.09982L8.09982 13.5003M8.09982 8.09982L13.5003 13.5003M19.8008 10.8C19.8008 15.771 15.771 19.8008 10.8 19.8008C5.82908 19.8008 1.79932 15.771 1.79932 10.8C1.79932 5.82908 5.82908 1.79932 10.8 1.79932C15.771 1.79932 19.8008 5.82908 19.8008 10.8Z" stroke="#111827" stroke-width="2" stroke-linecap="round"/>
  </svg>`,

  promo_bar_link: `<svg viewBox="0 0 9 8" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.1569 0.155598C4.94944 -0.0518659 4.61306 -0.0518659 4.4056 0.155598C4.19815 0.363067 4.19815 0.699433 4.4056 0.906902L6.68621 3.1875H0.53125C0.237846 3.1875 0 3.42534 0 3.71875C0 4.01216 0.237846 4.25 0.53125 4.25H6.68621L4.4056 6.5306C4.19815 6.73806 4.19815 7.07444 4.4056 7.2819C4.61306 7.48935 4.94944 7.48935 5.1569 7.2819L8.34392 4.09493C8.34525 4.0936 8.34652 4.09227 8.34785 4.09089C8.44162 3.99542 8.49958 3.86463 8.5 3.72034V3.71716C8.49979 3.6457 8.4855 3.5776 8.45968 3.51539C8.43375 3.45275 8.39534 3.39405 8.3444 3.3431L5.1569 0.155598Z" fill="#ffffff"/>
  </svg>`,
  
  zap: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2"></polygon>
  </svg>`,
  
  pawPrint: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="11" cy="4" r="2"></circle>
    <circle cx="18" cy="8" r="2"></circle>
    <circle cx="20" cy="16" r="2"></circle>
    <path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"></path>
  </svg>`,
  
  target: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"></circle>
    <circle cx="12" cy="12" r="6"></circle>
    <circle cx="12" cy="12" r="2"></circle>
  </svg>`,
  
  plane: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path>
  </svg>`,
  
  ruler: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M21 14H3l-.5-2L21 6v8z"></path>
    <line x1="21" y1="6" x2="3" y2="12"></line>
  </svg>`,
  
  clock: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12,6 12,12 16,14"></polyline>
  </svg>`,
  
  play: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polygon points="5,3 19,12 5,21 5,3"></polygon>
  </svg>`,
  
  user: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>`,

  users: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>`,
  
  thumbsUp: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M7 10v12"></path>
    <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h3.73a2 2 0 0 1 1.92 2.56Z"></path>
  </svg>`,
  
  car: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M8 21h8l-2-6H10l-2 6z"></path>
    <path d="M16 16h6l-2-6h-6l2 6z"></path>
    <path d="M6 16l2-6H2l2 6h2z"></path>
    <path d="M12 2L8 8h8l-4-6z"></path>
  </svg>`,
  
  home: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9,22 9,12 15,12 15,22"></polyline>
  </svg>`,
  
  building: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M3 21h18"></path>
    <path d="M5 21V7l8-4v18"></path>
    <path d="M19 21V11l-6-4"></path>
  </svg>`,
  
  wrench: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
  </svg>`,
  
  wind: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"></path>
    <path d="M9.6 4.6A2 2 0 1 1 11 8H2"></path>
    <path d="M12.6 19.4A2 2 0 1 0 14 16H2"></path>
  </svg>`,
  
  x: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>`,
  
  chevronLeft: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polyline points="15,18 9,12 15,6"></polyline>
  </svg>`,
  
  chevronRight: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polyline points="9,18 15,12 9,6"></polyline>
  </svg>`,
  
  arrowRight: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12,5 19,12 12,19"></polyline>
  </svg>`,
  
  timer: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12,6 12,12 16,14"></polyline>
  </svg>`,
  
  sparkles: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M12 3a6.364 6.364 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
  </svg>`,
  
  globe: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>`,
  
  award: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
    <path d="M4 22h16"></path>
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
  </svg>`,
  
  phone: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>`
};

// Make icons available globally
window.DogGoodsIcons = DogGoodsIcons; 